<template>
    <CustomDialog v-model="show">
        <template #header>
            <div class="text-lg font-medium text-gray-370 dark:text-white uppercase">
                {{ name }} Carrier
            </div>
        </template>

        <div
            class="px-7.5 py-5 max-mob:p-4 w-99.5 max-mob:w-full"
            @keyup.enter="submitForm"
        >
            <div class="mb-3 text-gray-370 dark:text-white text-xs">
                Carrier Name
            </div>

            <FormInput
                v-model="formData.name.value"
                v-model:valid="formData.name.valid"
                :rules="rules.default"
                :readonly="readonly"
                placeholder="Type Carrier Name"
                autoFocus
            />
        </div>

        <template #footer>
            <div class="flex items-center justify-end w-full gap-x-5">
                <TextBtn @click="onClose">
                    Cancel
                </TextBtn>

                <PrimaryBtn
                    v-if="!readonly"
                    :loading="loading"
                    @click="submitForm"
                >
                    {{ name }}
                </PrimaryBtn>
            </div>
        </template>
    </CustomDialog>
</template>

<script setup>
import { computed, reactive, watch } from 'vue'

import CustomDialog from '@/components/dialogs/CustomDialog.vue'
import TextBtn from '@/components/buttons/TextBtn.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import FormInput from '@/components/inputs/FormInput.vue'

import { checkFormValidity, collectFormData } from '@/helpers/app-helper'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    selectedItem: {
        type: Object,
        default: () => ({}),
    },
    readonly: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['update:modelValue', 'createAction', 'editAction'])

const formData = reactive({
    name: {
        value: '',
        valid: false,
    },
})

const rules = reactive({
    default: [],
})

const show = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emits('update:modelValue', value)
    },
})

const isEdit = computed(() => props.selectedItem?.slug)

const name = computed(() => {
    if (props.readonly) {
        return 'View'
    }

    if (isEdit.value) {
        return 'Update'
    }

    return 'Block'
})

function setRules() {
    rules.default = [
        (v) => !!v || 'This field is required',
    ]
}

function parseProps(item) {
    Object.keys(formData).forEach((key) => {
        formData[key].value = item[key]
    })
}

function onClose() {
    show.value = false
}

async function submitForm() {
    await setRules()

    const valid = checkFormValidity(formData)

    if (valid) {
        actionSuccess()
    }
}

function actionSuccess() {
    const formDataForSend = collectFormData(formData)

    if (isEdit.value) {
        emits('editAction', formDataForSend, props.selectedItem.slug)
    } else {
        emits('createAction', formDataForSend)
    }
}

watch(show, (show) => {
    if (show) {
        rules.default = []
        parseProps(props.selectedItem)
    }
})
</script>
